module.exports = __webpack_public_path__ + "static/img/报警.490e2a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/车辆/汽车吊/报警.png
// module id = BsI+
// module chunks = 76